export const LOGO_SRC = "/ewta_logo.png";

const SIZES = { sm: "h-14 w-14", md: "h-[4.5rem] w-[4.5rem]", lg: "h-24 w-24" };

// Single source of truth for rendering the EWTA / HER Aligned logo.
// Always `object-contain` inside a square box with breathing room so the full
// outer ring is visible, centred and never cropped, zoomed or stretched.
export default function BrandLogo({ size = "sm", className = "" }) {
  return (
    <div className={`${SIZES[size] || SIZES.sm} flex items-center justify-center p-1 shrink-0 ${className}`}
         data-testid="brand-logo">
      <img src={LOGO_SRC} alt="The Empowered Woman Transformation Academy"
           className="h-full w-full object-contain" draggable="false" />
    </div>
  );
}
